export const entry_strategy_status = {
  0: { name: 'Desactivado', color: 'danger' },
  1: { name: 'Activo', color: 'success' },
};
